var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactListBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 717.479,
    height: 517.223,
    viewBox: "0 0 717.479 517.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M290.665,673.819v1.339a8.378,8.378,0,0,0,8.371,8.371h70.986a8.374,8.374,0,0,0,8.371-8.371v-1.339a8.311,8.311,0,0,0-1.942-5.357,8.612,8.612,0,0,0-1.413-1.339H338.218a1.675,1.675,0,0,1-1.674-1.674H299.035A8.383,8.383,0,0,0,290.665,673.819Z",
    transform: "translate(-187.101 -229.11)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 8.706,
    height: 61.61,
    transform: "translate(151.449 515.697) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M308.122,759.5c0,.941,13.192.364,29.466.364s29.466.577,29.466-.364-13.192-8.4-29.466-8.4S308.122,758.557,308.122,759.5Z",
    transform: "translate(-190.157 -244.106)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M306.439,670.091l29.707,4.741,34.515,5.511,11.967,1.909a4.394,4.394,0,0,0,5.023-3.643l.542-3.389.5-3.154.415-2.6a4.344,4.344,0,0,0-.83-3.322,4.24,4.24,0,0,0-1.627-1.339H340.332a1.675,1.675,0,0,1-1.674-1.674v-1.319a1.675,1.675,0,0,1,1.674-1.674h18.2l-8.391-1.339-25.8-4.119-15.061-2.4a4.4,4.4,0,0,0-5.036,3.65l-1.46,9.134a4.411,4.411,0,0,0,3.649,5.029Z",
    transform: "translate(-189.215 -226.794)",
    fill: "#ffc61a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M385.078,671.49v51.036a4.393,4.393,0,0,0,4.386,4.386h9.262a4.393,4.393,0,0,0,4.387-4.386V671.49a4.33,4.33,0,0,0-.918-2.672,4.232,4.232,0,0,0-1.7-1.339h-12.8A4.256,4.256,0,0,0,386,668.818,4.341,4.341,0,0,0,385.078,671.49Z",
    transform: "translate(-203.631 -229.466)",
    fill: "#ffc61a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M351.237,565.071a4.419,4.419,0,0,0,.348,1.319,4.324,4.324,0,0,0,1.252,1.641l.02.013,26.425,21.436.388.308,5.471,4.44,1.654,1.339h28.615l-1.647-1.339L391.149,575.88l-15.155-12.3L364.2,554.022a4.343,4.343,0,0,0-2.424-.964.021.021,0,0,0-.013-.007,4.451,4.451,0,0,0-.79.013,4.218,4.218,0,0,0-1.145.281,3.222,3.222,0,0,0-.71.362,4.229,4.229,0,0,0-1.091.958l-5.746,7.078-.087.114A4.354,4.354,0,0,0,351.237,565.071Z",
    transform: "translate(-197.702 -209.429)",
    fill: "#ffc61a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M353.036,568.034a10.857,10.857,0,0,0,2.136,3.368l17.592,18.9a4.386,4.386,0,0,0,6.208-.275l.489-.556.214-.241,7.6-8.525,3.268-3.67a3.854,3.854,0,0,0,.562-.75c.081-.134.154-.275.221-.415a4.443,4.443,0,0,0,.368-1.989,4.327,4.327,0,0,0-1.44-3.06l-20.4-15.59a10.925,10.925,0,0,0-7.9-2.183.021.021,0,0,0-.013-.007,11.491,11.491,0,0,0-1.848.388c-.268.074-.529.167-.8.268a10.793,10.793,0,0,0-4.453,3.148,10.934,10.934,0,0,0-1.808,11.19Z",
    transform: "translate(-197.881 -209.418)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 33.565,
    cy: 33.565,
    r: 33.565,
    transform: "translate(113.237 260.934)",
    fill: "#ffc000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M331.459,664.483l12.449,1.982.282.047,18.925,3.02,11.927,1.909,17.532,2.8.5.08,2.6.415,11.967,1.909A4.394,4.394,0,0,0,412.671,673l1.045-6.536.415-2.6c0-.013.007-.027.007-.04H344.712a1.675,1.675,0,0,1-1.674-1.674v-1.319a1.675,1.675,0,0,1,1.674-1.674h21.938v-7.32l-1.339-.214-6.616-1.058-24.4-3.891a4.4,4.4,0,0,0-5.029,3.643l-.543,3.382-.918,5.759A4.4,4.4,0,0,0,331.459,664.483Z",
    transform: "translate(-193.595 -225.814)",
    fill: "#ffc61a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M287.7,616.62c0,27.363,2.779,43.73,45.639,39.042l.174-.02a127.263,127.263,0,0,0,22.588-4.319,67.085,67.085,0,0,0,11.143-4.366c.844-.429,1.654-.877,2.451-1.339h-32a1.675,1.675,0,0,1-1.674-1.674v-1.319a1.675,1.675,0,0,1,1.674-1.674h21.938v-42.3a4.916,4.916,0,0,1,4.909-4.909h17.847c-.154-.442-.308-.891-.475-1.339a109.714,109.714,0,0,0-5.94-13.514,103.086,103.086,0,0,0-11.1-17.13,71.342,71.342,0,0,0-9.938-10.172c-6.717-5.545-14.03-8.974-21.45-8.974C306.124,542.614,287.7,589.256,287.7,616.62Z",
    transform: "translate(-186.582 -207.604)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M342.218,504.054l-.035-1.254c2.333-.065,4.391-.211,5.937-1.341a3.856,3.856,0,0,0,1.494-2.84,2.2,2.2,0,0,0-.723-1.815c-1.026-.867-2.677-.586-3.881-.034l-1.038.476,1.99-14.544,1.243.17-1.693,12.372a4.428,4.428,0,0,1,4.188.6,3.431,3.431,0,0,1,1.167,2.817,5.1,5.1,0,0,1-2.007,3.809C346.873,503.924,344.292,504,342.218,504.054Z",
    transform: "translate(-196.121 -197.114)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 6.756,
    height: 1.254,
    transform: "translate(157.229 286.824)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 6.756,
    height: 1.254,
    transform: "translate(135.906 286.824)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M302.547,471.851c2.61-3.93,7.2-5.6,11.733-6,5.1-.456,10.025.527,15,1.482,5.478,1.051,11.276,2.035,16.8.706a16.558,16.558,0,0,0,11.255-9.093,21.18,21.18,0,0,0,1.233-14.123,25.672,25.672,0,0,0-8.4-12.745c-7.944-6.794-18.695-9.847-29.035-9.56a49.088,49.088,0,0,0-28.457,10.006,46.221,46.221,0,0,0-16.4,25.7,48.185,48.185,0,0,0,2.333,30.307c2.263,5.249,5.535,9.981,8.06,15.1,2.351,4.764,4.162,10.3,2.7,15.617a14.486,14.486,0,0,1-9.784,10.071,10.274,10.274,0,0,1-11.425-4.664c-2.365-3.729-2.422-8.614,1.129-11.625a8.717,8.717,0,0,1,12.575,1.255,8.972,8.972,0,0,1,1.795,6.578c-.175,1.184,1.638,1.7,1.814.5A10.614,10.614,0,0,0,265.69,514.5c-2.141,4.026-.986,8.883,1.732,12.325a12.013,12.013,0,0,0,12.248,4.4,16.214,16.214,0,0,0,10.9-9.7c2.119-5.145,1.148-10.887-.918-15.88-2.233-5.4-5.55-10.237-8.172-15.438a43.968,43.968,0,0,1-4.461-15.022,47.534,47.534,0,0,1,6.779-30.109,44.178,44.178,0,0,1,24.333-18.493,46.17,46.17,0,0,1,30.551.808c9.56,3.767,18.792,11.976,18.681,23a16.952,16.952,0,0,1-5.4,12.654c-4.311,3.754-10.314,4.075-15.734,3.489-5.454-.59-10.75-2.182-16.228-2.589-4.764-.353-9.9.014-14.158,2.381a14.156,14.156,0,0,0-4.918,4.562c-.672,1.011.957,1.955,1.625.95Z",
    transform: "translate(-182.534 -186.574)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M317,579.479a3.536,3.536,0,0,0,.18.355,3.8,3.8,0,0,0,.221.348l14.679,21.128,1.139,1.641,11.974,17.224L356.744,636.8l4.674,6.737a3.9,3.9,0,0,0,.422.516,4.374,4.374,0,0,0,2.739,1.339h.12V616.66l-1.339-1.929-15.021-21.617L332.207,569.9a4.4,4.4,0,0,0-6.108-1.1l-4.949,3.435-2.659,1.848a4.386,4.386,0,0,0-1.493,5.4Z",
    transform: "translate(-191.644 -212.05)",
    fill: "#ffc61a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M314.047,577.915l.663,1.333.007.007.181.355,10.762,21.363a4.4,4.4,0,0,0,6.034,1.473l.7-.435.174-.107,13.876-8.706a4.384,4.384,0,0,0,1.46-6.054l-15.242-20.666a10.955,10.955,0,0,0-13.38-3.456,10.785,10.785,0,0,0-1.487.817,10.958,10.958,0,0,0-3.744,14.076Z",
    transform: "translate(-190.989 -211.002)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M410.1,667.478V717.9a4.393,4.393,0,0,0,4.387,4.386h9.262a4.393,4.393,0,0,0,4.386-4.386v-50.42Z",
    transform: "translate(-208.012 -229.465)",
    fill: "#ffc61a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M344.658,653.19v1.319a3.024,3.024,0,0,0,2.424,2.96c.094.013.187.033.281.04s.2.013.308.013H450.909a6.256,6.256,0,0,0,6.255-6.247V609.22a6.256,6.256,0,0,0-6.255-6.248H374.518a6.255,6.255,0,0,0-6.248,6.248v40.957h-20.6a3.014,3.014,0,0,0-3.013,3.013Z",
    transform: "translate(-196.554 -218.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M344.658,653.19v1.319a3.024,3.024,0,0,0,2.424,2.96c.094.013.187.033.281.04s.2.013.308.013H450.909a6.256,6.256,0,0,0,6.255-6.247V609.22a6.256,6.256,0,0,0-6.255-6.248H374.518a6.255,6.255,0,0,0-6.248,6.248v40.957h-20.6a3.014,3.014,0,0,0-3.013,3.013ZM346,654.51V653.19a1.675,1.675,0,0,1,1.674-1.674H369.61v-42.3a4.916,4.916,0,0,1,4.909-4.909h76.39a4.917,4.917,0,0,1,4.915,4.909v42.055a4.917,4.917,0,0,1-4.915,4.909H347.671A1.675,1.675,0,0,1,346,654.51Z",
    transform: "translate(-196.554 -218.171)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 5.15,
    cy: 5.15,
    r: 5.15,
    transform: "translate(211.012 406.927)",
    fill: "#ffc61a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 1.339,
    height: 6.027,
    transform: "translate(171.737 432.716)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M958.069,168.237H601.7a.825.825,0,1,1,0-1.65H958.069a.825.825,0,0,1,0,1.65Z",
    transform: "translate(-241.414 -141.768)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 7.46,
    cy: 7.46,
    r: 7.46,
    transform: "translate(384.163 0)",
    fill: "#003050"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 7.46,
    cy: 7.46,
    r: 7.46,
    transform: "translate(409.935 0)",
    fill: "#003050"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 7.46,
    cy: 7.46,
    r: 7.46,
    transform: "translate(435.705 0)",
    fill: "#003050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M674.911,304.163a43.832,43.832,0,1,1,43.831-43.832,43.832,43.832,0,0,1-43.831,43.832Zm0-86.013a42.182,42.182,0,1,0,42.182,42.182,42.182,42.182,0,0,0-42.182-42.182Z",
    transform: "translate(-246.702 -150.507)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 20.383,
    cy: 20.383,
    r: 20.383,
    transform: "translate(405.384 332.655)",
    fill: "#d2d4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M667.523,570.874l-.021-.762a6.3,6.3,0,0,0,3.605-.814,2.341,2.341,0,0,0,.907-1.725,1.339,1.339,0,0,0-.439-1.1,2.307,2.307,0,0,0-2.357-.021l-.63.289,1.209-8.832.755.1-1.028,7.513a2.689,2.689,0,0,1,2.543.366,2.084,2.084,0,0,1,.708,1.711,3.1,3.1,0,0,1-1.219,2.313A7.01,7.01,0,0,1,667.523,570.874Z",
    transform: "translate(-253.079 -210.281)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 4.102,
    height: 0.762,
    transform: "translate(421.204 348.377)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 4.102,
    height: 0.762,
    transform: "translate(408.255 348.377)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M673.955,544.3c-4.918,3.375-12.471,1.514-14.7-4.188a10.509,10.509,0,0,1,.434-8.633,11.014,11.014,0,0,1,7.673-5.288c4.217-.874,8.577.3,12.432,2a.766.766,0,0,0,.869-.112c3.682-2.935,9.031-1.661,12.806.391a28.412,28.412,0,0,1,10.051,9.509,29.128,29.128,0,0,1-6.935,39.467c-.731.547-.016,1.793.724,1.239a30.737,30.737,0,0,0-2.338-51.008c-4.528-2.724-10.839-4.187-15.323-.612l.869-.112c-3.855-1.7-8.08-2.908-12.328-2.349a13.013,13.013,0,0,0-9.224,5.288,11.806,11.806,0,0,0-1.413,9.647,10.718,10.718,0,0,0,6.447,7.07,11.622,11.622,0,0,0,10.68-1.072c.757-.519.04-1.763-.724-1.239Z",
    transform: "translate(-251.256 -204.427)",
    fill: "#003050"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 20.12,
    cy: 20.12,
    r: 20.12,
    transform: "translate(407.072 96.297)",
    fill: "#d2d4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M676.068,285.014a7.259,7.259,0,0,1-4.178-.995,3.208,3.208,0,0,1-1.263-2.4,2.159,2.159,0,0,1,.734-1.773,2.785,2.785,0,0,1,2.635-.379l-1.065-7.782.782-.107,1.252,9.149-.653-.3a2.389,2.389,0,0,0-2.441.022,1.387,1.387,0,0,0-.455,1.142,2.425,2.425,0,0,0,.939,1.786,6.526,6.526,0,0,0,3.734.844Z",
    transform: "translate(-253.625 -160.151)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 4.25,
    height: 0.789,
    transform: "translate(411.191 112.21)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 4.25,
    height: 0.789,
    transform: "translate(424.604 112.21)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M681.3,255.821a11.61,11.61,0,0,1-10.427,4.834,9.068,9.068,0,0,1-7.936-7.1,11.705,11.705,0,0,1,3.076-10.333,17.975,17.975,0,0,1,10.637-5.008,26.484,26.484,0,0,1,20.647,6.471,25.291,25.291,0,0,1,6.586,8.827,24.745,24.745,0,0,1,2.042,10.683,26.99,26.99,0,0,1-8.87,19.292,24.98,24.98,0,0,1-2.134,1.671c-.625.438-1.217-.587-.6-1.022a25.36,25.36,0,0,0,10.172-17.07,23.641,23.641,0,0,0-5.544-19.071,25.955,25.955,0,0,0-18.054-8.8c-6.923-.3-15.575,2.789-16.871,10.5A8.268,8.268,0,0,0,667.9,258.5a9.471,9.471,0,0,0,10.457-1.3,12.012,12.012,0,0,0,1.918-1.977c.456-.6,1.485-.008,1.022.6Z",
    transform: "translate(-252.243 -154.276)",
    fill: "#003050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M674.911,444.328A43.832,43.832,0,1,1,718.742,400.5a43.832,43.832,0,0,1-43.831,43.832Zm0-86.013A42.182,42.182,0,1,0,717.093,400.5a42.182,42.182,0,0,0-42.182-42.182Z",
    transform: "translate(-246.702 -175.047)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M674.911,593.894a43.832,43.832,0,1,1,43.831-43.831A43.832,43.832,0,0,1,674.911,593.894Zm0-86.013a42.182,42.182,0,1,0,42.182,42.182,42.182,42.182,0,0,0-42.182-42.182Z",
    transform: "translate(-246.702 -201.234)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 20.816,
    cy: 20.816,
    r: 20.816,
    transform: "translate(404.41 208.822)",
    fill: "#d2d4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M671,422.521a7.509,7.509,0,0,1-4.322-1.029,3.319,3.319,0,0,1-1.306-2.479,2.233,2.233,0,0,1,.759-1.834,2.881,2.881,0,0,1,2.726-.392l-1.1-8.051.809-.111,1.3,9.465-.675-.31a2.471,2.471,0,0,0-2.526.023,1.435,1.435,0,0,0-.47,1.182,2.509,2.509,0,0,0,.972,1.848,6.752,6.752,0,0,0,3.864.873Z",
    transform: "translate(-252.706 -184.145)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 4.396,
    height: 0.816,
    transform: "translate(406.657 225.285)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 4.396,
    height: 0.816,
    transform: "translate(420.534 225.285)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M676.766,430.068l14.4-5.588c2.354-.914,4.722-1.8,7.064-2.745a8.051,8.051,0,0,0,2.719-1.6,5.343,5.343,0,0,0,1.356-2.623,27.027,27.027,0,0,0,.373-6.572,50.08,50.08,0,0,0-.58-7.037,33.993,33.993,0,0,0-4.347-12.4c-4.038-6.625-10.995-11.609-19-11.212a16.268,16.268,0,0,0-10.183,4.046,6.434,6.434,0,0,1-.961.932,1.334,1.334,0,0,1-.766.051q-.5-.032-1.008-.049a20.833,20.833,0,0,0-3.5.147,11.069,11.069,0,0,0-5.767,2.395,7.033,7.033,0,0,0-2.61,4.71,5.575,5.575,0,0,0,1.883,4.551c1.718,1.448,4.169.939,6.229.83l7.548-.4,3.824-.2c.787-.042.785,1.183,0,1.224l-10.165.539a44.444,44.444,0,0,1-4.952.2,5.54,5.54,0,0,1-3.4-1.368,6.787,6.787,0,0,1-2.056-6.368,9.1,9.1,0,0,1,4.574-5.81c2.974-1.677,6.526-1.838,9.853-1.59l-.433.179a17.843,17.843,0,0,1,14.943-5.149,22.362,22.362,0,0,1,14.45,8.178,33.649,33.649,0,0,1,7.154,17.155,57.081,57.081,0,0,1,.442,10.155,12.8,12.8,0,0,1-.756,4.388,6.282,6.282,0,0,1-2.949,3.162,42.213,42.213,0,0,1-4.681,1.923l-5.3,2.059-10.419,4.044-2.652,1.029c-.735.285-1.053-.9-.326-1.181Z",
    transform: "translate(-250.493 -178.965)",
    fill: "#003050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M701.641,381.444a6.326,6.326,0,1,1,6.326,6.326A6.326,6.326,0,0,1,701.641,381.444Zm1.224,0a5.1,5.1,0,1,0,5.1-5.1,5.1,5.1,0,0,0-5.1,5.1Z",
    transform: "translate(-259.056 -178.278)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M963.442,289.057H819.389a6.785,6.785,0,1,1,0-13.57H963.442a6.785,6.785,0,1,1,0,13.57Z",
    transform: "translate(-278.484 -160.834)",
    fill: "#809faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M916.99,260.9h-97.6a6.785,6.785,0,1,1,0-13.57h97.6a6.785,6.785,0,1,1,0,13.57Z",
    transform: "translate(-278.484 -155.905)",
    fill: "#809faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M963.442,429.222H819.389a6.785,6.785,0,1,1,0-13.57H963.442a6.785,6.785,0,1,1,0,13.57Z",
    transform: "translate(-278.484 -185.375)",
    fill: "#809faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M916.99,401.067h-97.6a6.785,6.785,0,1,1,0-13.57h97.6a6.785,6.785,0,1,1,0,13.57Z",
    transform: "translate(-278.484 -180.445)",
    fill: "#809faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M963.442,578.788H819.389a6.785,6.785,0,1,1,0-13.57H963.442a6.785,6.785,0,1,1,0,13.57Z",
    transform: "translate(-278.484 -211.561)",
    fill: "#809faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M916.99,550.633h-97.6a6.785,6.785,0,1,1,0-13.57h97.6a6.785,6.785,0,1,1,0,13.57Z",
    transform: "translate(-278.484 -206.632)",
    fill: "#809faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M480.238,763.15H165.945a.825.825,0,0,1,0-1.65H480.238a.825.825,0,1,1,0,1.65Z",
    transform: "translate(-165.12 -245.927)",
    fill: "#3f3d56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactListBg);
export default __webpack_public_path__ + "static/media/contact-list-bg.b4c5401ec6edf3a223db15f2195b9a7b.svg";
export { ForwardRef as ReactComponent };